import { Visible } from '@leroy-merlin-br/backyard-react-ui'

const Wishlist = () => (
  <section className="my-wishlist">
    <div className="my-wishlist-icon">
      <a href="/minhas-listas-de-desejos">
        <i className="glyph glyph-heart"></i>
        <Visible giga tera>
          <div className="content">
            Listas de Favoritos
          </div>
        </Visible>
      </a>
    </div>
  </section>
)

export default Wishlist
